import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreateServiceOrderModel,
  DeleteServiceOrderModel,
  SearchServiceOrderModel,
} from '../../../models/service-order.model'

@Injectable({
  providedIn: 'root',
})
export class ServiceOrderService {
  private baseUrl = environment.baseUrl
  private resource = 'OrdemServico'
  private resourceItineraries = 'OrdemServicoItinerario'

  constructor(private httpClient: HttpClient) {}

  public createServiceOrder(
    model: CreateServiceOrderModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editServiceOrder(
    model: any,
    // model: EditServiceOrderModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public deleteServiceOrder(
    model: DeleteServiceOrderModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete`,
      model,
    )
  }

  public listPagedServiceOrder(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedServiceOrderOrdenation(
    page: number,
    rows = 15,
    id: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceItineraries}/listpaginated-ordenacao?pageNumber=${page}&pageSize=${rows}&osId=${id}`,
    )
  }

  public listServiceOrder(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }

  public getServiceOrderbyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedServiceOrder(
    page: number,
    rows = 15,
    model: SearchServiceOrderModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  // Fila do operador (Acompanhamento de OS) — não confundir com a listagem da Torre
  // de Monitoramento, que saiu de AgendaFrota/search-paginated/monitoramento e foi
  // para Monitoramento/search-paginated (MonitoringService), um recurso próprio.
  public searchPagedAcompanhamento(
    page: number,
    rows = 15,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/acompanhamento/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public createServiceOrderItinerary(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceItineraries}/create`,
      model,
    )
  }

  public editServiceOrderItinerary(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceItineraries}/edit`,
      model,
    )
  }

  public editServiceOrderEditStatus(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit-status`,
      model,
    )
  }

  // Progresso do trajeto (status_ordem_servico_andamento) — diferente do status geral
  // gravado por editServiceOrderEditStatus/edit-status. {codigoOs} é o mesmo id tipo
  // "TG26-3848-0001" usado em cancelServiceOrder/confirmarOperador, não um Guid.
  public getHistoricoAndamento(codigoOs: string): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${codigoOs}/historico-andamento`,
    )
  }

  // model: { id: codigoOs, statusId, itinerarioId?, observacao?, dataOcorrido?, horaOcorrido? }
  // itinerarioId é obrigatório quando statusId = 7 (Parada). Sem dataOcorrido/horaOcorrido
  // a API carimba a hora do servidor. Pode devolver 400 com mensagem pronta pra exibir
  // (transição inválida, motorista/veículo faltando, OS cancelada, etc).
  public editStatusAndamento(model: any): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit-status-andamento`,
      model,
    )
  }

  // Avança sozinho pra próxima etapa do andamento (inclusive Parada/Destino) e aceita
  // a OS quando ela ainda está Agendada. Não manda status nenhum.
  public checkAndamento(codigoOs: string): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/check-andamento`,
      { ordemServicoId: codigoOs },
    )
  }

  public removeServiceOrderItinerary(
    id: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceItineraries}/remove/${id}`,
      id,
    )
  }

  public getServiceOrderItineraryStopbyId(
    id: any,
    rows = 15,
    page: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceItineraries}/OrdemServico-paginated/parada/${id}%20?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public getServiceOrderParents(
    idOS: string,
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/ordem-servico?pageNumber=${page}&pageSize=${rows}`,
      { ordemServicoId: idOS },
    )
  }

  public importDataServiceOrderParents(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/import/ordens-servico`,
      model,
    )
  }

  public searchPagedServiceOrderByProposal(
    page: number,
    rows = 15,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated/proposta?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public transferirResponsavel(
    codigoOs: string,
    destino: 'FROTA' | 'COMPRAS',
  ): Observable<ResponseRequestModel> {
    return this.httpClient.put<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${codigoOs}/transferir-responsavel/${destino}`,
      {},
    )
  }

  public cancelServiceOrder(codigoOs: string): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/cancelar/${codigoOs}`,
      {},
    )
  }

  // Fila do operador (status 12 — Aguardando Confirmação Operador), tela de monitoramento-os.
  // {osId} no path é, na prática, o codigoOs (ex: "TG25-6164-0061"), não um Guid — mesmo padrão
  // de transferirResponsavel. Todas as 4 rotas devolvem OrdemServicoOperacaoLoteVm
  // ({ aplicadas: string[], ignoradas: { ordemServicoId, motivo }[] }), inclusive as individuais
  // (lote de um só) — um único tratamento no componente serve pros dois casos.
  public confirmarOperador(codigoOs: string): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${codigoOs}/confirmar-operador`,
      {},
    )
  }

  public recusarOperador(codigoOs: string, motivo: string): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${codigoOs}/recusar-operador`,
      { motivo },
    )
  }

  public confirmarOperadorLote(ordemServicoIds: string[]): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/confirmar-operador/lote`,
      { ordemServicoIds },
    )
  }

  public recusarOperadorLote(ordemServicoIds: string[], motivo: string): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/recusar-operador/lote`,
      { ordemServicoIds, motivo },
    )
  }
}
